export class ANGULAR_SERVICE_WORKER_MESSAGE_TYPES {
  static readonly success = [
    'VERSION_DETECTED',
    'VERSION_READY',
    'NO_NEW_VERSION_DETECTED'
  ];
  static readonly failure = [
    'VERSION_INSTALLATION_FAILED',
    'UNRECOVERABLE_STATE'
  ];
}

export class ANGULAR_SERVICE_WORKER_MESSAGE_ACTIONS {
  static readonly success = [
    'INITIALIZE'
  ];
  static readonly failure = [
  ];
}
